export default "__VITE_ASSET__B6853pVt__"